import axios from 'axios';
// import API from '../../plugins/api';
// import router from '../../router'

export default {
  state: {
    connect: false,
    user: localStorage.getItem("user") != null ? JSON.parse(localStorage.getItem("user")) : null,
    token: localStorage.getItem("token") != null ? localStorage.getItem("token") : null
  },
//   getters: {
//     connectionState: state => state.connect,
//     loggedInUser: state => state.loggedInUser,
//     loading: state => state.loading,
//     error: state => state.error,
//     working: state => state.working,
//     getAuth: state => {
//       if(localStorage.getItem("userInfo") != null){
//         let user = JSON.parse(localStorage.getItem("userInfo"))
//         axios.defaults.headers.common['Authorization'] = user.token;
//         return JSON.parse(user.permisos)
//       } else {
//         return { 
//           admin: false,
//           catalogos: [false, false, false, false, false],
//           bancos: [false, false, false, false, false],
//           compras: [false, false, false, false, false],
//           ventas: [false, false, false, false, false],
//           inventario: [false, false, false, false, false],
//           cyc: [false, false, false, false, false]
//         }
//       }
//     },
//   },
  mutations: {
//     "SOCKET_CONNECT": (state,  status ) => {
//       state.connect = true;
//     },
//     "SOCKET_disconnect": (state,  status ) => {
//       state.connect = false;
//     },
    setSession(state, data) {
      localStorage.setItem('user', JSON.stringify(data.user));
      localStorage.setItem('token', data.token);
      state.user = data.user;
      state.token = data.token;
    },
//     setLogout(state) {
//       state.loggedInUser = null;
//       state.loading = false;
//       state.error = null;
//       state.auth = null;
//     },
//     setLoading(state, data) {
//       state.loading = data;
//       state.error = null;
//     },
//     setError(state, data) {
//       state.error = data;
//       state.loggedInUser = null;
//       state.loading = false;
//     },
//     clearError(state) {
//       state.error = null;
//     },
//     setAuth(state, data) {
//       state.auth = data
//     },
//     setWorking(state, data){
//       state.working = data
//     },
//     setFoto(state, foto){
//       state.loggedInUser.foto = foto
//     }
  },
//   actions: {
//     login({commit}, data) {
//       commit("clearError")
//       commit("setWorking", true)

//       API
//       .post('/v1/auth/login', data)
//       .then( res => {
//         if(res.data){
//           const newUser = res.data;
//           localStorage.setItem("userInfo", JSON.stringify(newUser));
//           API.defaults.headers.common['Authorization'] = res.data.token;
//           commit("setUser", res.data)
//           commit("setAuth", JSON.parse(res.data.permisos))
//           router.push('/');
//         } else {
//           commit("setError", 'Credenciales incorrectas !');
//         }

//         commit("setWorking", false)

//       })
//       .catch(e => console.log(e))
//     },
//     signOut({commit}) {
//       return new Promise((resolve, reject) => {
//         console.log('CERRAR SESION')
//         localStorage.removeItem("userInfo");
//         commit("setLogout");
//         API.defaults.headers.common['Authorization'] = '';
//         resolve(true)
//       })
//     },
//     checkPermiso({ commit, state }, acceso){
//       return new Promise((resolve, reject) => {
//         let auth = JSON.parse(state.loggedInUser.permisos)

//         if(auth['admin']){
//           resolve(true)
//         }

//         if(acceso[0] == 'admin'){
//           resolve(auth['admin'])
//         }

//         resolve(auth[acceso[0]][acceso[1]])
//       })
//     }
//   }
};
